import type { ReportBlock } from '@/lib/types/report'

/** Ghost placeholder for a section the agent has not written yet (live views only).
 *  Carries its own muted header — the renderer skips SectionHeader for this type. */
export function PendingSection({ block }: { block: ReportBlock }) {
  const title = block.title ?? block.id ?? 'Section'
  return (
    <div
      role="status"
      aria-label={`${title} — not written yet`}
      className="print:hidden rounded-lg border border-dashed border-border/70 px-5 py-4"
    >
      <p className="text-sm font-medium text-muted-foreground">{title}</p>
      <div className="mt-3 space-y-2" aria-hidden="true">
        <div className="h-2 w-4/5 rounded bg-muted/60" />
        <div className="h-2 w-3/5 rounded bg-muted/40" />
      </div>
    </div>
  )
}
